import { Injectable } from '@angular/core';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpModalComponent } from './help-modal.component';
import { ContentfulService } from '../shared/services/contentful.service';
import { LanguageService } from '../shared/services/language.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HelpModalService {
  currentHelpModalType: string;
  currentHelpModalRef: NgbModalRef;

  constructor(
    private contentfulService: ContentfulService,
    private language: LanguageService,
    private modalService: NgbModal,
  ) {}

  // Loads Contentful resource 'help' by resource type
  // type should match content's 'resource' parameter
  // Each resource should have copies in all languages,
  // matched by language property
  open(type: string) {
    if (this.currentHelpModalType) {
      if (this.currentHelpModalType !== type) {
        this.currentHelpModalRef.dismiss();
      } else {
        return;
      }
    }

    this.currentHelpModalType = type;

    const content$ = this.contentfulService
      .getByResource(this.language._current, 'help', type)
      .pipe(map((item) => (item ? item.fields : null)));

    this.currentHelpModalRef = this.modalService.open(HelpModalComponent, {
      // container: '.main-content',
      // backdropClass: 'transparent',
      // windowClass: 'fixed-right fade',
    });

    this.currentHelpModalRef.componentInstance.type = type;
    this.currentHelpModalRef.componentInstance.content$ = content$;

    this.currentHelpModalRef.result
      .then(() => (this.currentHelpModalType = null))
      .catch(() => (this.currentHelpModalType = null));
  }

  close() {
    if (this.currentHelpModalType) {
      this.currentHelpModalRef.dismiss();
    }
  }
}
